import SelectBox from "./SelectBoxPrimitive";
import YearDropdownItem from "./YearDropdownItem";
import { range } from "d3";
import { memo } from "react";

export enum YearSelectionRole {
  StartYear = "StartYear",
  EndYear = "EndYear",
  FixedYear = "FixedYear",
}

type YearItem = { label: string; value: number };

interface YearDropdownProps {
  /** The currently selected year value */
  value: number | undefined;
  /** Called when the user selects a new year */
  onChange: (year: number) => void;
  /** Minimum year available */
  yearMin: number;
  /** Maximum year available */
  yearMax: number;
}

const YearDropdown = ({
  value,
  onChange,
  yearMin,
  yearMax,
}: YearDropdownProps) => {
  const items: YearItem[] = range(yearMin, yearMax + 1, 1)
    .map(
      (year: number): YearItem => ({
        label: String(year),
        value: year,
      }),
    )
    .reverse(); // Reversing here so that year values are in descending order

  const dispatchAction = ({ value: selectedValue }: { value: string | number }) => {
    onChange(Number(selectedValue));
  };

  let matchSelectedItem: YearItem | undefined = undefined;
  if (value !== undefined) {
    matchSelectedItem = items.find(
      (item: YearItem) => item.value === Number(value),
    );
  }

  return (
    <>
      <SelectBox
        items={items}
        hashFunction={(item: YearItem) => item.value}
        placeholder="Please select a year"
        ItemRenderComponent={YearDropdownItem}
        onChangeEvent={dispatchAction}
        selectedValueFromStore={matchSelectedItem}
      />
    </>
  );
};

export default memo(YearDropdown);
